import React, { useState } from 'react'
import { useGetOrgSubscriptionsQuery } from "@/features/orgSubscriptions/orgSubscriptionsApiSlice"
import {
  PlusIcon,
  MinusIcon,
  Squares2X2Icon,
  ArrowTrendingUpIcon,
} from "@heroicons/react/24/outline"

const EtTrinityUserPacks = ({userOrgId="", userId="", profileInfo={}}) => {

  // First Created: 09 May 2025
  // Author: Atul Pandey 
  // Inheritence - Extracted from EtUserInduction


  // 1 - State Variables
  const [showSubscriptions, setShowSubscriptions] = useState(false)
  const [showTrails, setShowTrails] = useState(false)
  const [showTrailsMap, setShowTrailsMap] = useState({})

  // 2a - Data from RTK queries
  const { data: orgSubscriptionsData } = useGetOrgSubscriptionsQuery()
  const orgSubscriptions = orgSubscriptionsData?.ids?.map(id => orgSubscriptionsData?.entities[id]) || []
  const userSubscriptions = orgSubscriptions?.filter(item => item.orgId._id === userOrgId)

  // 2b - Count total trails
  const totalTrailCount = userSubscriptions?.reduce((acc, subscription) => {
    subscription?.subsPackId?.forEach(subsPack => {
      acc += subsPack?.subscriptionPackTrails?.length || 0
    })
    return acc
  }, 0)

  // 2c - Count trails per pack
  const trailCountBySubsPack = userSubscriptions?.reduce((acc, subscription) => {
    subscription?.subsPackId?.forEach(subsPack => {
      const packName = subsPack?.subscriptionPackName || "Unnamed Pack"
      const trailCount = subsPack?.subscriptionPackTrails?.length || 0
      acc[packName] = (acc[packName] || 0) + trailCount
    })
    return acc
  }, {})

  // 3 - CreateMarup function
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }


  return (
    <div className=''>
      {/* Section 1 - Packs */}
      <div className='m-1 p-1 bg-gray-200 rounded'>
        <div className='grid grid-cols-8 justify-start items-center'>
          <div className={`col-span-3 flex justify-start items-center m-1 p-1`}>
            <div
              onClick={() => setShowSubscriptions(prev => !prev)}
              className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
            >
              {showSubscriptions ? (
                <MinusIcon className="h-4 w-4 text-orange-600" />
              ) : (
                <PlusIcon className="h-4 w-4 text-orange-600" />
              )}
            </div>
            <div className="flex justify-center items-center rounded-full h-8 w-8 bg-gray-50 hover:bg-white cursor-pointer" onClick={() => setShowSubscriptions(prev => !prev)} >
              <Squares2X2Icon className='h-6 w-6 text-orange-600' />
            </div>
            <div>
              <p className='mx-1 px-1 font-bold text-gray-600'>Packs</p>
              <p className='mx-1 px-1 text-gray-700 text-xs italic'>what induction powers can I avail?</p>
            </div>
          </div>
          <div className='col-span-1 flex justify-start items-center'>
            <div className='rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50 m-1'>
              <p className='text-orange-600 text-[10px]'>{userSubscriptions?.length}</p>
            </div>
          </div>
        </div>

        {showSubscriptions && (
          <div className='bg-gray-50 m-1 p-1 rounded'>
            {userSubscriptions?.length === 0 ? (
              <p className='text-orange-600 text-sm m-1 p-1'>No subscriptions have been assigned yet for your org.</p>
            ) : (
              userSubscriptions?.map((item, itemIndex) => {
                const subsPack = item.subsPackId[0]
                return (
                  <div key={item._id + itemIndex} className='m-1 p-1 flex justify-start items-center bg-gray-100'>
                    <div className='m-1 p-1'><p className='text-4xl mx-1 px-1 text-gray-700 font-bold'>{itemIndex + 1}.</p></div>
                    <div className='rounded-full flex justify-center items-center m-1 p-1'>
                      <img src={subsPack.pic} alt="" className='h-10 w-10' />
                    </div>
                    <div className='m-1 p-1'>
                      <p className='text-gray-600 mx-1 px-1 font-bold'>{subsPack.subscriptionPackName}</p>
                      <p dangerouslySetInnerHTML={createMarkup(subsPack.subscriptionPackDesc)} className='text-xs text-gray-600 mx-1 px-1 max-w-xl'></p>
                    </div>
                  </div>
                )
              })
            )}
          </div>
        )}
      </div>

      {/* Section 2 - Trails */}
      <div className='m-1 p-1 bg-gray-200 rounded'>
        <div className='grid grid-cols-8 justify-start items-center'>
          <div className={`col-span-3 flex justify-start items-center m-1 p-1`}>
            <div
              onClick={() => setShowTrails(prev => !prev)}
              className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
            >
              {showTrails ? (
                <MinusIcon className="h-4 w-4 text-orange-600" />
              ) : (
                <PlusIcon className="h-4 w-4 text-orange-600" />
              )}
            </div>
            <div className="flex justify-center items-center rounded-full h-8 w-8 bg-gray-50 hover:bg-white cursor-pointer" onClick={() => setShowTrails(prev => !prev)} >
              <ArrowTrendingUpIcon className='h-6 w-6 text-orange-600' />
            </div>
            <div>
              <p className='mx-1 px-1 font-bold text-gray-600'>Trails</p>
              <p className='mx-1 px-1 text-gray-700 text-xs italic'>what are my induction pathways?</p>
            </div>
          </div>
          <div className='col-span-1 flex justify-start items-center'>
            <div className='rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50 m-1'>
              <p className='text-orange-600 text-[10px]'>{totalTrailCount}</p>
            </div>
          </div>
        </div>

        {showTrails && (
          <div className='bg-gray-50 m-1 p-1 rounded'>
            {userSubscriptions?.map((item, itemIndex) => {
              const subsPack = item.subsPackId[0]
              const subsPackId = subsPack._id
              const trails = subsPack.subscriptionPackTrails || []
              const show = showTrailsMap[subsPackId]

              return (
                <div key={subsPackId + itemIndex} className='m-1 p-1 bg-gray-100 rounded'>
                  <div className='grid grid-cols-8 justify-start items-center'>
                    <div className='col-span-2 flex justify-start items-center'>
                      <div
                        onClick={() => setShowTrailsMap(prev => ({ ...prev, [subsPackId]: !prev[subsPackId] }))}
                        className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
                      >
                        {show ? <MinusIcon className="h-4 w-4 text-orange-600" /> : <PlusIcon className="h-4 w-4 text-orange-600" />}
                      </div>
                      <div className='rounded-full flex justify-center items-center m-1 p-1'>
                        <img src={subsPack.pic} alt="" className='h-6 w-6' />
                      </div>
                      <p className='text-xs font-bold text-gray-700 mx-1'>{subsPack.subscriptionPackName}</p>
                    </div>
                    <div className='col-span-1'>
                      <div className='rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50 m-1'>
                        <p className='text-orange-600 text-[10px]'>{trailCountBySubsPack[subsPack.subscriptionPackName]}</p>
                      </div>
                    </div>
                  </div>

                  {show && trails?.map((trail, trailIndex) => {
                    const t = trail.packTrailId
                    return (
                      <div key={t._id + trailIndex} className='bg-white m-1 p-1 rounded flex items-center'>
                        <p className='text-sm text-gray-600 font-bold mx-1 px-1'>{trailIndex + 1}.</p>
                        <img src={t.pic} alt="" className='h-10 w-10 rounded-full m-1' />
                        <div className='mx-2'>
                          <p className='text-sm font-bold text-gray-700'>{t.trailName}</p>
                          <p className='text-xs text-gray-600' dangerouslySetInnerHTML={createMarkup(t.trailDesc)}></p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default EtTrinityUserPacks